// extracted by mini-css-extract-plugin
export var contact = "contact-mod--contact--3bys2";
export var form_input = "contact-mod--form_input--2zYtk";
export var form_textarea = "contact-mod--form_textarea--3I1hz";